import type { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { noop } from 'lodash';
import type { FC, PropsWithChildren } from 'react';
import React, { createContext, useContext } from 'react';

const CampaignCreateModalContext = createContext<() => void>(noop);
export const useShowCampaignCreateModal = (): (() => void) => useContext<() => void>(CampaignCreateModalContext);

export interface CreateCampaignProviderProps {
  readonly campaignCreateModal: ReturnType<typeof useRenderToggleableContent>;
}

export const CreateCampaignProvider: FC<PropsWithChildren<CreateCampaignProviderProps>> = ({
  campaignCreateModal,
  children,
}) => {
  'use memo';

  const { showContent, content } = campaignCreateModal;

  return (
    <>
      <CampaignCreateModalContext.Provider value={showContent}>{children}</CampaignCreateModalContext.Provider>
      {content}
    </>
  );
};
